import createCargoForm from './createParameterFormModel';
const {
  formField: {
    // DATOS PARAMETROS 
    llegadas_tarde,
    salidas_tarde,
    salario_minimo,
    auxilio_transporte,
    interes_cesantias,
    year

  } 
} = createCargoForm;


export default {

  [llegadas_tarde.name]: '',
  [salidas_tarde.name]: '',
  [salario_minimo.name]: '',
  [auxilio_transporte.name]: '',
  [interes_cesantias.name]: '',
  [year.name]: '',

};

